import {SET_HIGHLIGHTED_ELEMENT_TAB, SET_SIDE_PANEL_CONTENT, SWITCH_GRID} from '../grid';

export enum SidePanelContent {
    'ELEMENTS',
    'SLIDE',
    'HIGHLIGHTED_ELEMENT',
}

export interface ISwitchGridAction {
    type: typeof SWITCH_GRID;
}

export interface ISetSidePanelContentAction {
    type: typeof SET_SIDE_PANEL_CONTENT;
    content: SidePanelContent;
}

export interface ISetHighlightedElementTabAction {
    type: typeof SET_HIGHLIGHTED_ELEMENT_TAB;
    tab: string | null;
}

export type GridReducerType = ISwitchGridAction | ISetSidePanelContentAction | ISetHighlightedElementTabAction;
